import { v4 as uuidv4 } from 'uuid';

import CommentSchema from 'Shared/utils/normalizeJSON/schemas/Comment.schema';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

import { showNotificationError } from 'Shared/helpers';

import CommentsConstants from '../constants/Comments.constants';
import * as CommentsAPI from '../api/Comments.api';

export const createCommentSuccess = payload => ({
  type: CommentsConstants.Actions.CREATE_COMMENT_SUCCESS,
  payload,
});

export const deleteCommentSuccess = slug => ({
  type: CommentsConstants.Actions.DELETE_COMMENT_SUCCESS,
  payload: slug,
});

export const updateCommentSuccess = payload => ({
  type: CommentsConstants.Actions.UPDATE_COMMENT_SUCCESS,
  payload,
});

export const createComment = data => dispatch => {
  const uuid = uuidv4();

  const dataToSend = { ...data, uuid };

  return CommentsAPI.createComment(dataToSend)
    .then(response => {
      dispatch(createCommentSuccess(normalizer(CommentSchema, response.data)));
      return response;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const deleteComment = commentSlug => dispatch => {
  return CommentsAPI.deleteComment(commentSlug)
    .then(response => {
      dispatch(deleteCommentSuccess(commentSlug));
      return response;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const updateComment = data => dispatch => {
  return CommentsAPI.updateComment(data)
    .then(response => {
      dispatch(updateCommentSuccess(normalizer(CommentSchema, response.data)));
      return response;
    })
    .catch(error => {
      showNotificationError(error);
    });
};
